/**
 * EngineeringNotesTable — collapsible Sunstellar vs Industry comparison table.
 * Default-collapsed (per ss-tank.html reference) and used at the bottom of
 * every SS Tank quotation. The notes are sourced from
 * `frontend/src/data/calc/ss-tank-engineering-notes.ts` which is parity-checked
 * against the backend snapshot.
 */
import type { EngineeringNote } from '../../types/calc';

export function EngineeringNotesTable({
  notes,
  collapsed = false,
}: {
  notes: ReadonlyArray<EngineeringNote>;
  collapsed?: boolean;
}) {
  return (
    <details
      open={!collapsed}
      className="rounded-lg border border-slate-200 bg-white"
    >
      <summary className="cursor-pointer px-4 py-3 font-medium text-slate-900">
        Sunstellar vs Industry standard — engineering comparison
      </summary>
      <div className="px-4 pb-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-slate-600 border-b border-slate-200">
              <th className="py-2 pr-3">Parameter</th>
              <th className="py-2 px-3 text-emerald-700">Sunstellar</th>
              <th className="py-2 pl-3 text-rose-700">Industry standard</th>
            </tr>
          </thead>
          <tbody>
            {notes.map((n, i) => (
              <tr key={i} className="border-b border-slate-100 align-top">
                <td className="py-2 pr-3 font-medium">{n.parameter}</td>
                <td className="py-2 px-3 text-slate-700">▸ {n.sunstellar}</td>
                <td className="py-2 pl-3 text-slate-700">✗ {n.industry}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </details>
  );
}
